import { render, staticRenderFns } from "./ReprintCard.vue?vue&type=template&id=3788b442&"
import script from "./ReprintCard.vue?vue&type=script&lang=js&"
export * from "./ReprintCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports